/**
 * 初始状态
 */
export const initialState = {
    contentLoading: false,
    contentPaddingBottom: 0
};

/**
 * get state
 * 用于在组件的mapStateToProps中获取state，所有关于state的处理都放到store中，不在组件中处理
 */
export const getContentLoading = state => {
    return state.home.contentLoading;
};

export const getContentPaddingBottom = state => {
    return state.home.contentPaddingBottom;
};
